import { ROUTE_NAMES } from '#/router/routes';
import React, { ImgHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

interface IProperties {
  id: string;
  image: ImgHTMLAttributes<HTMLImageElement>['src'];
  name: string;
}

const ArtistBanner = (properties: IProperties) => {
  const { id, image, name } = properties;
  return (
    <Link to={`${ROUTE_NAMES.ARTIST}/${id}`}>
      <div className="flex gap-4 w-full p-2 hover:bg-theme-light-gray/10 rounded-md">
        <div className="h-20 aspect-square">
          <img
            className="w-full h-full object-cover rounded-full"
            src={image}
            alt=""
          />
        </div>
        <div className="flex flex-col gap-2 justify-center">
          <span className="text-sm leading-none font-bold">Artist</span>
          <span className="text-base font-bold leading-none hover:underline">
            {name}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ArtistBanner;
